import * as React from 'react'
import Loader from '../../../Components/Loader'
import { Modal } from '../../../Components/Modal'
import { AdminIcon } from '../../../Icons/AdminIcon'
import { AdminTimeSlot } from '../AdminBookings';
import '../Adminbookings.css'
interface IRemoveTimeSlotsConfirmationModal{
 removeTimeSlot:(slotId: number) => Promise<void>;
 slotTomRemove:AdminTimeSlot;
 handleModal:(key:'delete'|'reschedule'|'send_material'|'submit-new-timeslots'|'remove-timeslots') => void;
 isSaving:boolean
}
export const RemoveTimeSlotsConfirmationModal = ({removeTimeSlot,slotTomRemove,handleModal,isSaving}:IRemoveTimeSlotsConfirmationModal) => {
    return(
        <Modal>
            <div style={{cursor:'pointer',width:35}} onClick={()=> handleModal('remove-timeslots')}>
                        <AdminIcon.CrossClose fill='hsl(var(--primary))'/>
                      </div>
                      <div className="sheet-header-container">
                    <h2 className="sheet-header-text">Ta bort ledig tid.</h2>
                    <p className="sheet-header-paragraph">
                      Är du säker på att du vill ta bort {slotTomRemove.date} - {slotTomRemove.time}
                    </p>
                  </div>
                   <div className="sheet-modal-footer">
                <button
          type="submit"
          className="sheet-form-submit-button"
          onClick={() => removeTimeSlot(slotTomRemove.id)}
        >
          {isSaving ? (<><Loader loaderSize='SMALL' bgColor='white'/>Sparar</>): (<><AdminIcon.Trashcan width={16} height={16} fill='white'/>
          Bekräfta borttagning</>)}
        </button>
        </div>
        </Modal>
    )
}
